import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

export const EventHeaderGroup = withConfig(theme => styled('header', { label: 'EventHeaderGroup' })`
    align-items: center;
    background-color: ${theme.star.collapse.competitionAndMarket.bgColor};
    color: ${theme.star.collapse.competitionAndMarket.txtColor};
    cursor: pointer;
    display: flex;
    flex-flow: row nowrap;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    height: 32px;
    justify-content: start;
    overflow: hidden;
    position: relative;
`);

export const CompetitionName = withConfig(theme => styled('h4', { label: 'CompetitionName' })`
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.3334;
    margin: 0;
    overflow: hidden;
    padding: 8px;
    text-overflow: ellipsis;
    text-transform: capitalize;
    user-select: none;
    white-space: nowrap;
`);

interface EventHeaderGroupSelectionPropsType {
    variant: DefaultComponentVariantType | null;
}

interface EventHeaderGroupSelectionsContainerPropsType {
    variant: DefaultComponentVariantType | null;
}

/** Mirrors EventRowSelectionsContainer — only used under unifiedSportEventsTable (Genius). */
export const EventHeaderGroupSelectionsContainer = withConfig(theme => styled('div', { label: 'EventHeaderGroupSelectionsContainer' })<EventHeaderGroupSelectionsContainerPropsType>`
    align-items: stretch;
    align-self: stretch;
    display: flex;
    flex: 0 0 444px;
    gap: ${theme.star.gap.small};
    margin-right: ${({ variant }): string =>
        variant === DefaultComponentVariantType.TERTIARY ? theme.star.padding.medium : theme.star.padding.small};
    width: 444px;

    @media ${theme.star.mediaQuery.xxLargeDesktop} {
        flex-basis: 480px;
        width: 480px;
    }
`);

const setHeaderSelection = (
    variant: DefaultComponentVariantType | null,
    isUnifiedEvents: boolean,
    theme: EmotionTheme
): SerializedStyles => {
    if (isUnifiedEvents === true) {
        return css`
            flex: 1 1 33.3334%;
            margin-right: 0;
            min-width: 0;
            padding: 8px 0;
            width: auto;
        `;
    }

    // Production / classic 6-pack header columns
    return css`
        flex: 0 0 150px;
        margin-right: ${variant === DefaultComponentVariantType.SECONDARY ? '4px' : '0'};
        padding: 8px;
        width: 150px;

        @media ${theme.star.mediaQuery.desktop} {
            flex-basis: 148px;
            width: 148px;
        }

        @media ${theme.star.mediaQuery.xxLargeDesktop} {
            flex-basis: 160px;
            width: 160px;
        }
    `;
};

interface EventHeaderGroupSelectionUnifiedPropsType extends EventHeaderGroupSelectionPropsType {
    isUnifiedEvents?: boolean;
}

export const EventHeaderGroupSelection = withConfig(theme => styled('div', { label: 'EventHeaderGroupSelection' })<EventHeaderGroupSelectionUnifiedPropsType>`
    align-items: center;
    display: flex;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.xMedium};
    justify-content: center;
    line-height: 1.2;
    ${({ variant, isUnifiedEvents = false }): SerializedStyles => setHeaderSelection(variant, isUnifiedEvents, theme)}
`);
